import React from 'react';
import { number, shape, string } from 'prop-types';
import { Col, Container, Row } from 'reactstrap';

import PrivacyContents from '../PrivacyContents';
import TextBox from '@components/TextBox/TextBox';
import Css from '../../Legal.scss';
import ImportImages from '@src/importImages';

const clouds = ImportImages('/legal/background-clouds.jpg');

const propTypes = {
  screenHeight: number.isRequired,
  textboxContent: shape({
    content: string.isRequired,
    header: string.isRequired,
    id: number.isRequired
  })
};

const Desktop = ({ screenHeight, textboxContent, heightSm }) => {
  return (
    <div
      id={'privacy'}
      className={'justify-content-center'}
      style={{ height: `${screenHeight}px` }}
    >
      <img
        src={clouds}
        alt={'Slider1'}
        className={'img-fluid d-none d-md-block'}
      />
      <Container
        fluid={true}
        className={'abs-container d-flex align-items-center'}
      >
        <Row className={heightSm ? 'h-70' : ''}>
          <Col md={{ offset: 1, size: 4 }} className={Css['header']}>
            <TextBox {...textboxContent} isHeader={true} />
          </Col>
          <Col
            md={{ offset: 1, size: 5 }}
            className={'align-self-center ' + (heightSm ? 'h-100' : 'h-60')}
          >
            <div
              className={
                Css['scroll-box'] + ' scrollable ' + (heightSm ? 'h-100' : '')
              }
            >
              <PrivacyContents />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Desktop.propTypes = propTypes;

export default Desktop;



// WEBPACK FOOTER //
// ./src/components/Legal/Privacy/Desktop/Desktop.jsx